import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";

const LogDetails = styled(({log, onClose}) => {
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>More about this action</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <p>{log.description}</p>
                </ModalBody>

                <ModalFooter>
                    <Button variant="cancel" onClick={onClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default LogDetails;
